import { emitActionViewEvent, emitFreshViewEvent } from './eventEmitter';

const buildTableTrackingData = (tableTracking, featureIndex) => {
  const { labels } = tableTracking;
  return {
    ...tableTracking,
    position: Number(featureIndex),
    status: 'loaded',
    labels: {
      ...labels,
      promo_Feature: ['true'],
      promo_FilledSlots: labels.promo_FilledSlots
    }
  };
};
const buildRecommendation = (recommendationTracking) => ({
  ...recommendationTracking,
  status: 'loaded'
});

const track = (tableTracking, recommendationsTracking, featureIndex, eventMergeId = null) => {
  const recommendationEvents = recommendationsTracking.map((it) => buildRecommendation(it));

  const event = [buildTableTrackingData(tableTracking, featureIndex), ...recommendationEvents];

  if (eventMergeId) {
    emitActionViewEvent(event, eventMergeId, 'change');
    return;
  }
  emitFreshViewEvent(event);
};

export default track;
